import { createSlice } from "@reduxjs/toolkit";

const gameSlice = createSlice({
  name: "game",
  initialState: {
    game: {
      gameId: "",
      gameName: "",
    },
    dayStartTime: '',
    dayEndTime: ''
  },
  reducers: {
    gameInfo: (state, action) => {
      state.game.gameId = action.payload
    },
    daySTime: (state, action) => {
      state.dayStartTime = action.payload
    },
    dayETime: (state, action) => {
      state.dayEndTime = action.payload
    }
  },
});

export const { gameInfo, daySTime, dayETime } = gameSlice.actions;
export default gameSlice.reducer;